import { css } from '@emotion/react'
import { MyLabel, MyLabelId } from '../../reducers/sourcingAnnotationCandidates'
import { OptionDropdown } from '@/components/view/OptionDropdown'
import { CheckboxDropdownItem } from '@/components/view/CheckboxDropdownItem'
import { Divider, colors } from 'plume-ui'
import { OptionDropdownItem } from '@/components/view/OptionDropdownItem'

type Props = {
  candidates: MyLabel[]
  selectedMyLabelIds: MyLabelId[]
  maxHeight?: number
  position?: { top?: number; right?: number; bottom?: number; left?: number }
  onSelectMyLabel: (id: MyLabelId) => void
  onDeselectMyLabel: (id: MyLabelId) => void
  onRequestEditModal: () => void
}

export const MyLabelDropdown: React.FC<Props> = ({
  candidates,
  selectedMyLabelIds,
  maxHeight = 320,
  position: { top, right, bottom, left } = {},
  onSelectMyLabel,
  onDeselectMyLabel,
  onRequestEditModal,
}) => {
  const isChecked = (id: MyLabelId) => selectedMyLabelIds.includes(id)

  const handleToggleMyLabel = (id: MyLabelId) => {
    if (isChecked(id)) {
      onDeselectMyLabel(id)
    } else {
      onSelectMyLabel(id)
    }
  }

  return (
    <OptionDropdown
      dataTestId="my-label-dropdown"
      open
      hideTopArrow
      _css={css`
        display: flex;
        flex-direction: column;
        min-width: 220px;
        max-height: ${maxHeight}px;
        overflow-y: auto;
        ${top != null ? `top: ${top}px;` : ''}
        ${right != null ? `right: ${right}px;` : ''}
        ${bottom != null ? `bottom: ${bottom}px;` : ''}
        ${left != null ? `left: ${left}px;` : ''}
      `}
    >
      <div
        css={css`
          flex: 1;
          overflow-y: auto;
          padding: 4px 0;
        `}
      >
        {candidates.length === 0 ? (
          <li
            css={css`
              padding: 7px 12px 4px 12px;
              color: ${colors.textLight};
              font-size: 14px;
              text-align: center;
              cursor: default;
            `}
          >
            まだマイラベル項目はありません
          </li>
        ) : (
          <>
            {candidates.map((item, i) => (
              <CheckboxDropdownItem
                key={`${item.id}-${i}`}
                checked={isChecked(item.id)}
                onClick={() => handleToggleMyLabel(item.id)}
              >
                {item.name}
              </CheckboxDropdownItem>
            ))}
          </>
        )}
      </div>
      <div
        css={css`
          flex-shrink: 1;
        `}
      >
        <Divider
          css={css`
            margin: 4px 0;
          `}
        />
        <OptionDropdownItem
          dataTestId={'my-label-edit-menu'}
          condition={true}
          idx={0}
          handleSet={(e) => {
            e.preventDefault()
            onRequestEditModal()
          }}
          label={'マイラベル項目を編集'}
          icon="icon-pen-fill"
          iconCss={css`
            color: ${colors.textLight};
          `}
        />
      </div>
    </OptionDropdown>
  )
}
